/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Other_ExtensionsInputs */

const en_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other extensions`)
};

const es_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otras extensiones`)
};

const fr_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres extensions`)
};

const de_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Endungen`)
};

const ja_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他の拡張子`)
};

const zh_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`其他后缀`)
};

const ar_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امتدادات أخرى`)
};

const id_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekstensi lainnya`)
};

const it_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre estensioni`)
};

const ru_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Другие расширения`)
};

const pt_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outras extensões`)
};

const ko_other_extensions = /** @type {(inputs: Other_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기타 확장자`)
};

/**
* | output |
* | --- |
* | "Other extensions" |
*
* @param {Other_ExtensionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const other_extensions = /** @type {((inputs?: Other_ExtensionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Other_ExtensionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_other_extensions(inputs)
	if (locale === "es") return es_other_extensions(inputs)
	if (locale === "fr") return fr_other_extensions(inputs)
	if (locale === "de") return de_other_extensions(inputs)
	if (locale === "ja") return ja_other_extensions(inputs)
	if (locale === "zh") return zh_other_extensions(inputs)
	if (locale === "ar") return ar_other_extensions(inputs)
	if (locale === "id") return id_other_extensions(inputs)
	if (locale === "it") return it_other_extensions(inputs)
	if (locale === "ru") return ru_other_extensions(inputs)
	if (locale === "pt") return pt_other_extensions(inputs)
	return ko_other_extensions(inputs)
});